import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import OurSponsors from "./ticketing/pages/OurSponsors";
import useFetch from "utils/hooks/useFetch";
import { GET_ALL_PUBLIC_POSTS } from "api";

function Home() {
  const { data: publicPosts, fetch: getAllPublicPosts } =
    useFetch(GET_ALL_PUBLIC_POSTS);
  const { t } = useTranslation();

  useEffect(() => {
    getAllPublicPosts();
  }, [getAllPublicPosts]);

  return (
    <div>
      <section className="hidden sm:block">
        <div className="relative">
          <img
            src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/5d6260b8cfe0d87c4a84f3a5be2650499d800596cfce422c1df4d6ad7ef66ac73e72223a02bc359af82907bc4962a5bde782b98cf6f04acd5b072181c840dee2e83264308a41794bba2f65554c8c1370a8beb05e7e4ade2120a9cbc270fb612404aad78654ef72d443bbe9abdcef9080e234b5b041345fd706c0/file-1751858972759.JPG"
            alt="main"
            className="max-h-[90vh] w-full object-cover object-center"
          />
          {/* <div className='absolute top-0 bottom-0 left-0 right-0 text-white'>
            <div className='app-main-container flex flex-col justify-center items-start h-full gap-4 sm:gap-8'>
              <p className='text-lg sm:text-3xl md:text-4xl max-w-md font-semibold sm:font-bold app-animation-translate-start'>{t('mainBannerText')}</p>
              <a href="/about">
                <button className='text-sm sm:text-base flex items-center gap-2 app-animation-translate-start'>
                  <p>{t('learnMore')}</p>
                  <ArrowRightIcon className='h-3 sm:h-4 w-3 sm:w-4 fill-white' />
                </button>
              </a>
            </div>
          </div> */}
        </div>
      </section>

      <section className="grid grid-cols-1 sm:grid-cols-2">
        <img
          src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/4a9fac104818dc4e9cd16cfaea5bbc076d0e5e38df8c084cc82adadcbb4c02555d69514d763a58fb63996d164d9a3e6dde1b95debb6f521df152a6e6afecb8cada4cdd69e494ed1c173653f5ff198309daf029c2615b420086fb72723a4ca1dc6cf388ea8edc3489b12f0aff1872f546251380b0ae68f4386bca/file-1750844992762.jpeg"
          alt="main"
          className="hidden sm:block w-full h-full aspect-video object-cover object-center app-animation-translate-right-start"
        />
        <img
          src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/f0a40adf29ed89601b9cee151e3b45e167fe5fac0a34e03acabb53174bf3e66b0a6c71c1e21e339ed0c5ff70139d7105569dfdb35478711540b006ab95e2532a710bdde98c09189bf0c2a812c5ce75392d519e28fe36f19845edfc320b4d7d6e1962f92aa34da2e30f64199c8e3a3a2856e8af07909c0b82ec8a/file-1751859045853.JPG"
          alt="main"
          className="sm:hidden w-full h-full object-cover object-center app-animation-translate-right-start"
        />
        <div className="bg-black text-white px-4 py-6 md:py-12 md:px-10 lg:px-20 flex items-center justify-center sm:justify-start">
          <div className="space-y-4 lg:space-y-8">
            <p className="text-2xl lg:text-4xl uppercase font-bold max-w-lg app-animation-translate-start">
              {t("mainBannerText")}
            </p>
            <p className="text-xl lg:text-3xl font-bold max-w-lg app-animation-translate-start">
              {t("firstHighlightText")}
            </p>
            <button
              onClick={() => window.location.assign("/prices")}
              className="text-lg sm:text-xl bg-gray-600 font-bold text-white rounded-md px-12 py-2 text-sm sm:text-base disabled:opacity-50 "
            >
              {t("registerNowButton")}
            </button>
          </div>
        </div>
      </section>

      <OurSponsors landingPage={true} />
    </div>
  );
}

export default Home;
